import React, { useEffect, useRef, useState } from "react";
import Agendas from "./Agendas";
import { UseAPICaller } from "../../apiCaller";

import "../../css/AppDialog.css";

import { ActivityListData, ReportInfo, SurveyListData } from "./FormDataTypes";
import { InfoIcon } from "../AppDialog";

export interface AppDialogProps {
  isOpen: boolean;
  ToSummary: () => void;
  onDialogClose?: () => void;
  reportData: ReportInfo;
  setReportData: React.Dispatch<React.SetStateAction<ReportInfo>>;
}


const ReportDialogContent : React.FC<AppDialogProps> = ({isOpen, ToSummary, onDialogClose, reportData, setReportData}) => {
    
    const{GetEditableReportInfo, UpdateReport, GetActivities, GetSurveys, UploadReportThumbnail, DeleteResource} = UseAPICaller();

    const [surveys, setSurveys] = useState<SurveyListData[]>([]);
    const [activities, setActivities] = useState<ActivityListData[]>([]);

    const GetReportData = async () =>{
        const reportId = +sessionStorage.getItem("reportId");
        if (reportId) 
        {
            const data = await GetEditableReportInfo(reportId);
            setReportData(data);
        }
    }

    useEffect(() => {
            if (!isOpen) return;
    
            const company = JSON.parse(sessionStorage.getItem("company"));
            

            const GetSurveyList = async () => {
                if (company) 
                {
                    const surveys = await GetSurveys(company.companyId);
                    setSurveys(surveys);
                }
            }

            const GetActivityList = async () => {
                if (company) 
                {
                    const activities = await GetActivities(company.companyId);
                    const formattedActivities : ActivityListData[] = activities.map(activity => {
                        return {
                            id:activity.id,
                            title:activity.title,
                            surveys:activity.surveyRows.map(s => s.id),
                            agendas:activity.agendaRows.map(a => a.id)
                        }
                    });
                    setActivities(formattedActivities);
                }
            }

            GetReportData();
            GetSurveyList();
            GetActivityList();

        }, [isOpen]);

    const OnAgendaChange = (newSelected: []) => {
        setReportData(prev => ({ ...prev, agendas: newSelected }));
    }

    const handleChange = (newData) => {
        setReportData((prev) => ({ ...prev, ...newData }));
    };

    const handleSurveyToggle = (id: number) => {
        setReportData((prev) => {
            const alreadySelected = prev.surveys.includes(id);
            const updatedSurveys = alreadySelected
                ? prev.surveys.filter((sid) => sid !== id)
                : [...prev.surveys, id];

            return { ...prev, surveys: updatedSurveys };
        });
    };

    const handleActivityToggle = (id: number) => {
        setReportData((prev) => {
            const alreadySelected = prev.activities.includes(id);
            const updatedActivities = alreadySelected
                ? prev.activities.filter((sid) => sid !== id)
                : [...prev.activities, id];


            let updatedSurveys = prev.surveys;
            if (!alreadySelected) {
                const selectedActivity = activities.find((a) => a.id === id);
                if (selectedActivity) {
                    const newSurveyIds = selectedActivity.surveys || [];
                    updatedSurveys = Array.from(new Set([...prev.surveys, ...newSurveyIds]));
                }
            }

            let updatedAgendas = prev.agendas;
            if (!alreadySelected) {
                const selectedActivity = activities.find((a) => a.id === id);
                if (selectedActivity) {
                    const newAgendaIds = selectedActivity.agendas || [];
                    updatedAgendas = Array.from(new Set([...prev.agendas, ...newAgendaIds]));
                }
            }

            return { ...prev, activities: updatedActivities, surveys: updatedSurveys, agendas: updatedAgendas };
        });
    };

    
    const OnSave = () => {
        const reportId = +sessionStorage.getItem("reportId");
        if (reportId) 
        {
            UpdateReport(reportId, reportData);
        }

    };

    const OnDelete = () => {
        if (window.confirm("Are you sure that you want to delete this report? \nThis is not reversable.")) {
            const reportId = +sessionStorage.getItem("reportId");
            if (reportId) 
            {
                DeleteResource("reports", reportId);
                if(onDialogClose)
                    onDialogClose();
            }
        }
    };

    const fileInputRef = useRef<HTMLInputElement | null>(null);
        
    const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const reportId = +sessionStorage.getItem("reportId");

        const res = await UploadReportThumbnail(reportId, file);

        if(res)
        {
            if (fileInputRef.current) 
                fileInputRef.current.value = '';
            GetReportData();
        }
    };

    const onUploadImage = () => {
        fileInputRef.current?.click();
    };

    return (
        <div className="dialog-body">
            <div className="dialog-column-left">
                <div style={{display:"flex", flexDirection:"column", gap:6}}>
                    <button className="dialog-button save-button" style={{borderStyle:"solid"}} onClick={OnSave}>Save</button>
                    <input
                        type="file"
                        ref={fileInputRef}
                        onChange={handleFileChange}
                        style={{ display: 'none' }}
                    />
                    <button className="dialog-button blue-button" onClick={onUploadImage}>{"Upload Cover (Max. 2mb)"}</button>
                    {/* <button className="dialog-button" style={{background:"blue", color:"white"}} onClick={() => alert("Export to PDF comming soon")}>Export PDF</button> */}
                    <button className="dialog-button blue-button" onClick={ToSummary}>Generate Summary</button>
                </div>
                <div style={{marginTop:"auto"}}>
                    <button className="dialog-button red-button" onClick={OnDelete}>Delete</button>
                </div>
            </div>
            <div className="dialog-column-middle">
                <div style={{display:"flex", gap:16}}>
                    <div style={{display:"flex", flexDirection:"column", gap:16}}>
                        <div style={{display:"flex", flexDirection:"column"}}>
                            <label>Name</label>
                            <input type="text" placeholder="Report name..." style={{width:"60%"}} value={reportData.title} onChange={e => handleChange( {title: e.target.value})}></input>
                        </div>
                        <div>
                            <label>Select dates</label>
                            <div>
                                <input type="date"  value={reportData.startDate} onChange={e => handleChange( {startDate: e.target.value})}></input>
                                <i className="fa fa-long-arrow-right"></i>
                                <input type="date" value={reportData.endDate} onChange={e => handleChange( {endDate: e.target.value})}></input>
                            </div>
                        </div>
                    </div>
                    
                    <div style={{display:"flex", flexDirection:"column"}}>
                        <label>Cover</label>
                        {reportData.thumbnailPath ? <img className="report-thumbnail" src={`http://185.7.62.58:5000/${reportData.thumbnailPath}`} alt="Image"></img> : <span>No cover image</span>}
                    </div>
                </div>
                <div style={{display:"flex", flexDirection:"column"}}>
                    <label>Description</label>
                    <textarea style={{width:"100%", minHeight:100, maxHeight:220}} value={reportData.description} onChange={e => handleChange( {description: e.target.value})}></textarea>
                </div>
                <div>
                    <div style={{display:"flex", paddingTop:"3px"}}>
                        <label>Surveys</label>
                        <InfoIcon text={"Select any survey that is connected with this report. More than one can be selected."}/>
                    </div>
                    <hr></hr>
                    <div className="survey-list">
                        {surveys.map((survey) => (
                            <label key={survey.id} className="survey-item">
                                <span className="survey-title">{survey.title}</span>
                                <input
                                    type="checkbox"
                                    checked={reportData.surveys.includes(survey.id)}
                                    onChange={() => handleSurveyToggle(survey.id)}
                                />
                            </label>
                        ))}
                    </div>
                </div>
            </div>
            <div className="dialog-column-right">
                <div>
                    <div style={{display:"flex", paddingTop:"3px"}}>
                        <label>Activities</label>
                        <InfoIcon text={"Select any activity that is connected with this report. More than one can be selected."}/>
                    </div>
                    <hr></hr>
                    <div className="activity-list">
                        {activities.map((activity) => (
                            <label key={activity.id} className="dialog-activity-item">
                                <span className="activity-title">{activity.title}</span>
                                <input
                                    type="checkbox"
                                    checked={reportData.activities.includes(activity.id)}
                                    onChange={() => handleActivityToggle(activity.id)}
                                />
                            </label>
                        ))}
                    </div>
                </div>
                <Agendas selected={reportData.agendas} onChange={OnAgendaChange} size={70}/>
            </div>
        </div>
    );
}

export default ReportDialogContent;